import { gsap } from 'gsap';
import mixitup from 'mixitup';

const Events = {
  getEvents: async () => {
    window.addEventListener('load', (event) => {
      setTimeout(() => {
        Events.navUnderline();
        if (!window.hasOwnProperty('c7Events')) return false;

        let c7Events = window.c7Events;
        let eventArray = [];

        console.log('c7Events', c7Events);

        c7Events.forEach((item) => {
          let titleNoEvent, image, fullURL, firstParagraph, eventDate, eventLocation, eventLinkCopy, eventExternalUrl, memberExclusive;

          for (let key in item) {
            if (key == 'title') {
              titleNoEvent = item[key].replace('Event: ', '');
            }

            if (key == 'image') {
              image = item[key];
            }

            if (key == 'slug') {
              let slug = item[key];
              let websiteUrl = window.location.origin;
              fullURL = `${websiteUrl}/product/${slug}`;
            }

            if (key == 'content') {
              let content = item[key];
              let firstParagraphWithTags = content.split('</p>')[0];
              firstParagraph = firstParagraphWithTags.replace(/(<([^>]+)>)/gi, '');
            }

            if (key == 'eventTicket') {
              let eventTicket = item[key];

              for (let key in eventTicket) {
                if (eventTicket.hasOwnProperty(key)) {
                  if (key == 'eventDate') {
                    let date = new Date(eventTicket[key]);
                    let month = date.toLocaleString('default', { month: 'long' });
                    let day = date.getDate();
                    let year = date.getFullYear();
                    eventDate = `${month} ${day}, ${year}`;
                  }
                }
              }
            }

            if (key == 'metaData') {
              for (let innerKey in item[key]) {
                if (innerKey == 'event-location') {
                  eventLocation = item[key][innerKey] || null;
                }

                if (innerKey == 'custom-event-link-copy') {
                  eventLinkCopy = item[key][innerKey] || null;
                }

                if (innerKey == 'external-url-for-event') {
                  eventExternalUrl = item[key][innerKey] || null;
                }

                if (innerKey == 'member-exclusive-event') {
                  memberExclusive = item[key][innerKey] || null;
                }
              }
            }
          }

          eventArray.push({
            titleNoEvent,
            image,
            fullURL,
            firstParagraph,
            eventDate,
            eventLocation,
            eventLinkCopy,
            eventExternalUrl,
            memberExclusive,
          });
        });

        eventArray.sort((a, b) => {
          let dateA = new Date(a.eventDate);
          let dateB = new Date(b.eventDate);
          return dateA - dateB;
        });

        eventArray = eventArray.filter((item) => {
          let eventDateTime = new Date(item.eventDate);
          let today = new Date();
          today.setHours(23, 59, 59, 999);

          return eventDateTime >= today;
        });

        Events.buildEvents(eventArray);
      }, 100);
    });
  },
  buildEvents: async (data) => {
    let events = data;
    console.log('buildEvents', events);

    function limitString(str) {
      if (str.length > 77) {
        return str.substring(0, 77) + '...';
      }
      return str;
    }

    function createSlug(string) {
      let slug = string
        .replace(/\s+/g, '-')
        .toLowerCase()
        .replace(/[^\w-]+/g, '');
      return slug;
    }

    events.forEach((item) => {
      let eventHtml = `
            <li class="gridder-list mix ${item.eventLocation ? createSlug(item.eventLocation) : ''}">
                <div class="rmbr event-card">
                    <div class="event-card__inner">
                        <div class="event-card__header">
                            <a href="${item.eventExternalUrl ? item.eventExternalUrl : item.fullURL}" tabindex="0"><img src="${item.image}" alt="${item.titleNoEvent} hero"></a>
                            <p class="event__location">${item.eventLocation ? item.eventLocation : ''}</p>  
                            <p class="event__memberexclusive">${item.memberExclusive ? 'Member Exclusive' : ''}</p>                      
                        </div>
                        <div class="event-card__body">
                            <p class="event__date">${item.eventDate}</p>
                            <h4  class="event__title"> <a href="${item.eventExternalUrl ? item.eventExternalUrl : item.fullURL}" tabindex="0">${item.titleNoEvent}</a></h4>
                            <p class="event__description">${item.firstParagraph ? limitString(item.firstParagraph) : ''}</p>
                            <a class="rmbr btn btn--with-arrow no-arrow" href="${item.eventExternalUrl ? item.eventExternalUrl : item.fullURL}" tabindex="0">${
        item.eventLinkCopy ? item.eventLinkCopy : 'More Information'
      }</a>
                        </div>
                    </div>
                </div>
            </li>`;

      document.querySelector('.gridder-faux-ctnr').insertAdjacentHTML('beforeend', eventHtml);
    });

    if (events.length == 0) {
      let eventHtml = `<p class="no-events">No Upcoming Events <br> Please check back again soon</p>`;
      document.querySelector('.gridder-faux-ctnr').insertAdjacentHTML('beforeend', eventHtml);
    }

    Events.eventMixitup();
  },
  navUnderline: function() {
    if (!document.body.contains(document.querySelector('.page-template-events_v2'))) return false;

    let navLinks = document.querySelectorAll('.js-nav-link');
    let navUnderline = document.querySelector('.js-nav-underline');

    [...navLinks].forEach((link) => {
      let styles = window.getComputedStyle(link);
      let linkWidth = link.clientWidth;
      let trueWidth = linkWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      link.dataset.width = trueWidth;

      link.addEventListener('click', (e) => {
        e.preventDefault();

        [...navLinks].forEach((link) => {
          link.classList.remove('active');
        });

        e.target.classList.add('active');

        const timeline = gsap.timeline({ defaults: { ease: 'power4.inOut' } });
        timeline.to(navUnderline, { duration: 0.3, x: e.target.offsetLeft }).to(navUnderline, { duration: 0.5, width: e.target.dataset.width }, '-=0.1');
      });
    });
  },
  eventMixer: '',
  eventMixitup: function() {
    let containerEl = document.querySelector('.gridder-faux-ctnr');

    if (!containerEl) return;

    try {
      Events.eventMixer = mixitup(containerEl);

      Events.applyFilterFromHash();
    } catch (error) {
      console.error('Mixitup initialization failed:', error);
    }
  },
  applyFilterFromHash: function() {
    const hash = window.location.hash.replace('#', '');
    const navLinks = document.querySelectorAll('.js-nav-link');
    const navUnderline = document.querySelector('.js-nav-underline');
    const validFilters = Array.from(navLinks).map((link) => link.dataset.filter.replace('.', ''));

    if (validFilters.includes(hash)) {
      navLinks.forEach((link) => {
        link.classList.remove('active');
      });

      const activeLink = Array.from(navLinks).find((link) => link.dataset.filter.replace('.', '') === hash);
      if (activeLink) {
        activeLink.classList.add('active');

        const timeline = gsap.timeline({ defaults: { ease: 'power4.inOut' } });
        timeline.to(navUnderline, { duration: 0.3, x: activeLink.offsetLeft }).to(navUnderline, { duration: 0.5, width: activeLink.dataset.width }, '-=0.1');
      }

      this.applyFilter('.' + hash);
    }
  },
  applyFilter: function(filter) {
    console.log('applyFilter', filter);
    if (Events.eventMixer && typeof Events.eventMixer.filter === 'function') {
      Events.eventMixer.filter(filter);
    } else {
      console.error('Events.eventMixer.filter is not a function');
    }
  },
  init: function() {
    this.getEvents();
    this.applyFilterFromHash();
  },
};

export default Events;
